import { CONFIG } from '../../core/config';
import { ViewModel } from '../../viewmodels/view-model';

export interface UserCatalogItem {
  id: string;
  userName: string;
  catalogName: string;
  createdDate: string;
  createdBy: string;
}

export class UserCatalog implements ViewModel {

  public readonly friendlyTypeNameSingular: string = 'User Catalog';
  public readonly apiRoute: string = CONFIG.apiRoutes.userCatalog;

  public catalogList: UserCatalogItem[];

  public json() {
    return this;
  }

  public loadFromJson(userCatalogList: UserCatalogItem[]) {
    this.catalogList = userCatalogList;
  }
}
